exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-error {}\r\n.page-error .error-mark {\r\n    margin-bottom: 33px;\r\n}\r\n\r\n.page-error header h1 {\r\n    font-size: 10em;\r\n    font-weight: 400;\r\n}\r\n\r\n.page-error header p {\r\n    margin-bottom: 30px;\r\n    font-size: 30px;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.page-error h2 {\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.page-error .error-advise {\r\n    margin-bottom: 25px;\r\n    color: #a9afb5;\r\n}\r\n\r\n.page-error .go-back:hover{text-decoration: underline}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/pages/admin/icontact/page-error/style.css
// module id = ../../../../../src/app/pages/admin/icontact/page-error/style.css
// module chunks = main